import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {IDestinationBox} from '../../interfaces/idestination-box';
import {IDestinationBoxElement} from '../../interfaces/idestination-box-element';

@Component({
  selector: 'app-holiday-destinations-slider',
  templateUrl: './holiday-destinations-slider.component.html',
  styleUrls: ['./holiday-destinations-slider.component.scss']
})
export class HolidayDestinationsSliderComponent implements OnInit {

  @Input() destinationBox$: Observable<IDestinationBox[]>;
  @Output() selectedDestination = new EventEmitter<IDestinationBoxElement>();
  selectedGroup: IDestinationBox;
  selectedDestinationInner: IDestinationBoxElement;

  config = {
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      480: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      },
      1600: {
        slidesPerView: 4
      }
    },
    centeredSlides: false,
    simulateTouch: false,
    containerModifierClass: 'destinations-thumbnail__',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };
  index;

  constructor() { }

  ngOnInit(): void {
  }

  selectDestination(destination: IDestinationBoxElement): void {
    this.selectedDestinationInner = destination;
    this.selectedDestination.emit(destination);
  }

  selectGroup(group: IDestinationBox): void {
    this.selectedGroup = group;
  }

  deselectGroup(): void {
    this.selectedGroup = undefined;
  }

}
